import React from 'react'

const LibecmsBanner = () => {
    return (
        <div className='libecms-banner'>
            <div className='content'>
                <div className='title'><h1>EMPOWER  YOUR DIGITAL  PRESENCE WITH  LIBECMS SOLUTIONS</h1></div>
                <div className='subtitle'><span>Streamline your content management with Liberyus CMS Solutions. Our innovative and user-friendly platforms are designed to help you create, organize, and publish content effortlessly, empowering your business with dynamic, scalable, and secure digital experiences.</span></div>
            </div>
        </div>
    )
}

export default LibecmsBanner
